import styled from "styled-components";
import { spacing, typographyMixin } from "@magicbi/ui-library";

export const Wrap = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2.5]};
  min-width: 0;
`;

export const Logo = styled.img`
  flex: none;
  height: 1.5rem;
  max-width: 4rem;
  object-fit: contain;
`;

export const Label = styled.span`
  min-width: 0;
  color: ${({ theme }) => theme.colors.text.secondary};
  ${typographyMixin("caption", 3)}
`;
